import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
export const userClientStateSelector = createSelector(userStateSelector, (user) => user.clients);
export const userClientsSelector = createSelector(userClientStateSelector, (clients) => clients.userClients);
export const currentAdminUserClientsSelector = createSelector(userClientStateSelector, (clients) => clients.currentAdminUserClients);
export const currentUserClientIdSelector = createSelector(userClientStateSelector, clients => clients.currentUserClientId);
export const currentUserClientSelector = createSelector(userClientStateSelector, clients => { var _a; return (_a = clients.userClients) === null || _a === void 0 ? void 0 : _a.find(userClient => { var _a; return ((_a = userClient.client) === null || _a === void 0 ? void 0 : _a._id) === clients.currentUserClientId; }); });
export const getCurrentUserClientSelector = createSelector(userClientStateSelector, clients => clients.currentUserClient);
export const getCurrentUserClientSettingsSelector = createSelector(getCurrentUserClientSelector, userClient => userClient === null || userClient === void 0 ? void 0 : userClient.settings);
export const userClientsErrorSelector = createSelector(userClientStateSelector, (clients) => clients.error);
export default {
    userClientsSelector,
    currentAdminUserClientsSelector,
    currentUserClientIdSelector,
    currentUserClientSelector,
    userClientsErrorSelector,
    getCurrentUserClientSelector,
    getCurrentUserClientSettingsSelector,
};
